define('blocks-cloud/b-html/b-html', function (require, exports, module) {
	'use strict';

	var toolkit = require('toolkit/b-toolkit/b-toolkit');
	var BToolkit = toolkit['b-toolkit'];

	var BHtml = toolkit.create('b-html', {});

	module.exports = BHtml;
});
